import LocalizedStrings from 'localized-strings';

import { getMobileAppLang } from 'features/Accounting/pages/Estimation/common/utils';

export const locales = new LocalizedStrings(
  {
    en: {
      currency: '€',
      error: 'An error occurred. Please try again.',
      faq: {
        question1: {
          subtitle:
            'Your VAT is automatically calculated from the turnover indicated on the previous page. Simply select the VAT rate applicable to your activity. At any time, you can modify the calculated VAT amount, by manually adding or subtracting the amount of your choice.',
          title: 'How is my VAT calculated?',
        },
        title: 'Learn more…',
      },
      form: {
        label: {
          vatAmount: 'Estimated collected VAT',
          vatOffset: 'Amount to add or deduct from my VAT',
          vatRate: 'Average applicable VAT rate (%)',
        },
      },
      subtitle:
        'Enter here your applicable VAT rate to be deducted from your turnover. You can adjust this amount manually if necessary, by adding or deducting any amount.',
      title: 'Your applicable VAT',
    },
    fr: {
      currency: '€',
      error: 'Une erreur est survenue. Veuillez réessayer.',
      faq: {
        question1: {
          subtitle:
            'Votre TVA est calculée automatiquement depuis le chiffre d’affaires TTC indiqué à la page précédente. Il vous suffit de sélectionner le taux de TVA applicable à votre activité. À tout moment, vous pouvez modifier le montant de TVA calculé, en ajoutant ou soustrayant manuellement le montant de votre choix.',
          title: 'Comment est calculée ma TVA ?',
        },
        title: 'En savoir plus…',
      },
      form: {
        label: {
          vatAmount: 'Estimation du montant de TVA encaissé',
          vatOffset: 'Somme à ajouter ou déduire de ma TVA',
          vatRate: 'Taux moyen de TVA applicable (%)',
        },
      },
      subtitle:
        'Indiquez ici votre taux de TVA applicable à déduire de votre chiffre d’affaires TTC. Vous pouvez ajuster ce montant manuellement si nécessaire, en ajoutant ou déduisant une somme.',
      title: 'Votre TVA applicable',
    },
  } as const,
  {
    customLanguageInterface: getMobileAppLang,
  },
);
